
module.exports = { 
      attributes: {"title":"footer","logoFooter":"/img/logo-poema.png","addressFooter":"SAS au capital de 10 000 000 CFP – RCS NOUMEA 2009 B 941 161\\\nN° RIAS NC - NC170012 - www.rias.nc","phoneFooter":"","mailFooter":"","socials":{"linkedin":"https://fr.linkedin.com/company/poe-ma-insurances","facebook":"https://www.facebook.com/poemanoumea"}},
    
      html: "",
     }